"use client";

import CaptchaProvider from "@casino/legacy/client/shared/Providers/CaptchaProvider";
import LightThemeProvider from "@casino/legacy/client/shared/ThemeProviders/LightThemeProvider";
import { MetaMaskProvider } from "metamask-react";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren;

// Everything the legacy Login/Register forms need, mounted with the auth modal
// rather than with the page: CaptchaProvider injects the floating reCAPTCHA badge
// on mount and removes it again on unmount, so mounting it here keeps the badge
// scoped to an open modal instead of the whole game page.
const AuthFormProviders: FC<Props> = ({ children }) => {
  return (
    <CaptchaProvider>
      <MetaMaskProvider>
        <LightThemeProvider>{children}</LightThemeProvider>
      </MetaMaskProvider>
    </CaptchaProvider>
  );
};

export default AuthFormProviders;
